/**
 * User Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UserAliasDuplicateBehaviour = 'ThrowError' | 'AddNumber';

export const UserAliasDuplicateBehaviour = {
    ThrowError: 'ThrowError' as UserAliasDuplicateBehaviour,
    AddNumber: 'AddNumber' as UserAliasDuplicateBehaviour
};

